import { Marker } from 'react-map-gl/mapbox';
import { Icon } from '@/components';
import type { LngLatBase } from '@/views/map/types';
import type { HoveredItem } from '@/features/hoverContext';
import classes from './HoverMarker.module.css';

interface HoverMarkerProps {
  hoverLocation: LngLatBase;
  isOverview: boolean;
  isSpanView: boolean;
  hoveredItem?: HoveredItem | null;
}

export const HoverMarker = ({
  hoverLocation,
  isOverview,
  isSpanView,
  hoveredItem,
}: HoverMarkerProps) => {
  if (!isOverview && !isSpanView) {
    return null;
  }

  const showTooltip = hoveredItem?.source === 'map';

  return (
    <Marker
      latitude={hoverLocation.lat}
      longitude={hoverLocation.lng}
      style={{ pointerEvents: 'none' }}
      anchor="bottom"
      offset={showTooltip ? [0, -4] : [0, 0]}
    >
      {showTooltip ? (
        <div className={classes.hoverTooltip}>{hoveredItem.groupName}</div>
      ) : (
        <div className={classes.hoverPin}>
          <Icon name="HoverPin" color="var(--mantine-color-white)" size={72} />
        </div>
      )}
    </Marker>
  );
};
